import Vue from 'vue'
import Vuex from 'vuex'
import { disconnectGoEasy } from '../utils/goeasy'

Vue.use(Vuex)

// 创建store实例
const store = new Vuex.Store({
    state: {
        IS_DEV: '0', //0=正式 1=测试
        // 存储token
        token: localStorage.getItem('token') || '',
        // 存储用户信息
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
        // 存储城市信息
        cityCode: '',
        // 存储认证状态
        certified: '',
    },
    mutations: {
        // 设置token
        SET_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        // 移除token
        REMOVE_TOKEN(state) {
            state.token = ''
            localStorage.removeItem('token')
        },
        // 设置用户信息
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
        },
        // 移除用户信息
        REMOVE_USER_INFO(state) {
            state.userInfo = {}
            localStorage.removeItem('userInfo')
        },
        // 更新用户信息（合并新旧信息）
        UPDATE_USER_INFO(state, newUserInfo) {
            state.userInfo = {
                ...state.userInfo,
                ...newUserInfo
            }
            localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
        },
        // 设置城市信息
        SET_CITY(state, {
            cityCode,
            cityName
        }) {
            state.cityCode = cityCode
            // 如果需要保存到localStorage，可以取消下面的注释
            // localStorage.setItem('cityCode', cityCode)
        },
        // 设置认证状态
        SET_CERTIFIED(state, certified) {
            state.certified = certified
        },
    },
    actions: {
        // 设置token
        setToken({
            commit
        }, token) {
            commit('SET_TOKEN', token)
        },
        // 移除token
        removeToken({
            commit
        }) {
            commit('REMOVE_TOKEN')
        },
        // 设置用户信息
        setUserInfo({
            commit
        }, userInfo) {
            commit('SET_USER_INFO', userInfo)
        },
        // 移除用户信息
        removeUserInfo({
            commit
        }) {
            commit('REMOVE_USER_INFO')
        },
        // 登录时同时设置token和用户信息
        login({
            commit
        }, {
            token,
            userInfo
        }) {
            commit('SET_TOKEN', token)
            commit('SET_USER_INFO', userInfo)
        },
        // 退出登录时同时移除token和用户信息
        logout({
            commit
        }) {
            commit('REMOVE_TOKEN')
            commit('REMOVE_USER_INFO')
            // 断开 GoEasy IM 连接
            disconnectGoEasy()
        },
        // 更新用户信息
        updateUserInfo({
            commit
        }, newUserInfo) {
            commit('UPDATE_USER_INFO', newUserInfo)
        }
    },
    getters: {
        // 获取token
        getToken: state => state.token,
        // 获取用户信息
        getUserInfo: state => state.userInfo,
        // 判断用户是否已登录（token存在且userInfo不为空对象）
        isLoggedIn: state => !!state.token && Object.keys(state.userInfo).length > 0,
        // 获取城市编码
        getCityCode: state => state.cityCode
    }
})

export default store